import { getDashboardBaseUrl } from '@/taskpane/services/config';

export const APP_SOURCE_URL =
  'https://marketplace.microsoft.com/en-us/product/wa200010668?tab=overview';

export function getDashboardLoginUrl(): string {
  return `${getDashboardBaseUrl().replace(/\/$/, '')}/login`;
}

export const OFFICE_HOSTS = [
  {
    id: 'word',
    name: 'Word',
    chromeTitle: 'Document1 — Word',
    paneLabel: 'Word documents',
    summary: 'The Word pane lists Word files only. Open one into the document you already have.',
    files: [
      { name: 'NDA-Acme.docx', meta: 'DOCX · 248 KB' },
      { name: 'Policy-v4.docx', meta: 'DOCX · 91 KB' },
      { name: 'Minutes.docx', meta: 'DOCX · 36 KB' },
    ],
  },
  {
    id: 'excel',
    name: 'Excel',
    chromeTitle: 'Book1 — Excel',
    paneLabel: 'Workbooks',
    summary: 'The Excel pane lists workbooks only. It will not show Word or PowerPoint files.',
    files: [
      { name: 'Q3-forecast.xlsx', meta: 'XLSX · 1.1 MB' },
      { name: 'Headcount.xlsx', meta: 'XLSX · 420 KB' },
      { name: 'Invoice-log.xlsx', meta: 'XLSX · 88 KB' },
    ],
  },
  {
    id: 'powerpoint',
    name: 'PowerPoint',
    chromeTitle: 'Presentation1 — PowerPoint',
    paneLabel: 'Decks',
    summary: 'The PowerPoint pane lists decks only. Open one into the active presentation.',
    files: [
      { name: 'Board-review.pptx', meta: 'PPTX · 4.2 MB' },
      { name: 'Kickoff.pptx', meta: 'PPTX · 2.0 MB' },
      { name: 'Security-brief.pptx', meta: 'PPTX · 890 KB' },
    ],
  },
] as const;

export type OfficeHostId = (typeof OFFICE_HOSTS)[number]['id'];

export const FEATURES = [
  {
    title: 'Biometric sign-in',
    body: 'Enter the mobile number registered with iVALT. Approve on your phone. The pane never stores a password.',
  },
  {
    title: 'Open into the current file',
    body: 'Each host opens only files it can edit. Word loads documents, Excel loads workbooks, PowerPoint loads decks.',
  },
  {
    title: 'Save back encrypted',
    body: 'Write edits as a new vault version, or save the current Office file as a new DocuID document. Plaintext never replaces the stored blob.',
  },
  {
    title: 'Share from the sidebar',
    body: 'Send access by email or mobile without leaving the host app. Recipients unlock with the same biometric flow.',
  },
] as const;

export const INSTALL_STEPS = [
  {
    title: 'Install from AppSource',
    body: 'Add iVALT DocuID from Microsoft AppSource, or ask your admin to install it for your organization.',
  },
  {
    title: 'Open Word, Excel, or PowerPoint',
    body: 'Use the add-in from inside the Office app. It sits beside the file you already have open.',
  },
  {
    title: 'Home tab, then DocuID',
    body: 'The shield button on the Home ribbon opens the pane beside your document.',
  },
  {
    title: 'Sign in and work',
    body: 'Use your registered mobile number. After biometric approval you can browse, open, save, and share.',
  },
] as const;

export const AUTH_STEPS = [
  {
    title: 'Enter your mobile number',
    body: 'Type the phone number registered with iVALT into the sidebar inside Word, Excel, or PowerPoint. There is no password field, ever.',
  },
  {
    title: 'Approve with biometrics',
    body: 'A push notification opens your iVALT app. Approve on your phone using biometrics. Approval is verified in seconds.',
  },
  {
    title: 'Vault unlocks locally',
    body: 'Your vault secret is decrypted on this device, not on the server. Per-document AES-GCM keys are derived here and never leave the browser.',
  },
] as const;

export { getMarketingUrl } from '@/taskpane/services/config';
